import { Component, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent {

  @Input() placeholder: string = ''
  @Input() searchButtonTooltip: string = null
  @Output() filterValue: Subject<string | null> = new Subject<string | null>()
  filterInputValue: string = null

  constructor() { }

  filter(filterValue: string): void {
    this.filterInputValue = filterValue
    this.filterValue.next(this.filterInputValue)
  }
}
